import {Mapper, MAPPER_NAMES, MapperKind} from '@/api/models/Feeds.ts';
import ChainMapperEditor from '@/pages/feeds/Editor/Mapper/Mappers/ChainMapper.tsx';
import LookupMapperEditor from '@/pages/feeds/Editor/Mapper/Mappers/LookupMapper.tsx';
import SplitMapperEditor from '@/pages/feeds/Editor/Mapper/Mappers/SplitMapper.tsx';
import TakeOneMapperEditor from '@/pages/feeds/Editor/Mapper/Mappers/TakeOneMapper.tsx';
import {Card, H3} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

export type ChangeFn = (mapper: Mapper) => void;

interface Props {
	mapper: Mapper | null,
	onChange: ChangeFn,
	children?: ReactNode,
}

export default function Mappers({mapper, onChange, children}: Props): ReactElement | null {
	if (!mapper)
		return null;

	return (
		<Card style={{marginTop: 10}}>
			<H3>{MAPPER_NAMES[mapper.kind]}</H3>
			{createEditor(mapper, onChange)}

			{children}
		</Card>
	);
}

function createEditor(mapper: Mapper, onChange: ChangeFn): ReactElement|null {
	if (!mapper)
		return null;

	switch (mapper.kind) {
		case MapperKind.Chain:
			return <ChainMapperEditor mapper={mapper} onChange={onChange} />;

		case MapperKind.Lookup:
			return <LookupMapperEditor mapper={mapper} onChange={onChange} />;

		case MapperKind.Split:
			return <SplitMapperEditor mapper={mapper} onChange={onChange} />;

		case MapperKind.TakeOne:
			return <TakeOneMapperEditor mapper={mapper} onChange={onChange} />;

		default:
			// @ts-ignore
			throw new Error(`Unrecognized mapper kind "${mapper.kind}"`);
	}
}
